import DIApi from './_diApi';

class JusticeDecisionGroupAPI extends DIApi {
  controllerName = 'JusticeDecisionGroups';
}

export default new JusticeDecisionGroupAPI();
